/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S3_L5Inputs */

const en_landing_guide_s3_l5 = /** @type {(inputs: Landing_Guide_S3_L5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social and ad variants: produce a family of versions from one approved master image.`)
};

const zh_landing_guide_s3_l5 = /** @type {(inputs: Landing_Guide_S3_L5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社媒与广告变体：从一张定稿主图衍生出一整套版本。`)
};

/**
* | output |
* | --- |
* | "Social and ad variants: produce a family of versions from one approved master image." |
*
* @param {Landing_Guide_S3_L5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s3_l5 = /** @type {((inputs?: Landing_Guide_S3_L5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S3_L5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s3_l5(inputs)
	return zh_landing_guide_s3_l5(inputs)
});
export { landing_guide_s3_l5 as "landing.guide.s3_l5" }